export const AGREEMENT_STATUS = {
  ALL_STATUS: 0,
  REQUEST_RECEIVED: 1,
  SETUP_IN_PROGRESS: 2,
  AGREEMENT_OUT_FOR_SIGNATURE: 3,
  AGREEMENT_COMPLETED: 4,
  BROKER_ACTION_REQUIRE: 5,
  NOT_PROCEEDING: 6,
};
